import { CONVERSATION_MESSAGES, CONVERSATION_TITLE_LENGTH } from "./../Constants";

// Returns an error message when the title is invalid, otherwise null
export const validateConversationTitle = (newTitle: string): string | null => {
  if (!newTitle || newTitle === "") {
    return CONVERSATION_MESSAGES.TITLE_REQUIRED;
  }

  if (newTitle.length < CONVERSATION_TITLE_LENGTH.MIN || newTitle.length > CONVERSATION_TITLE_LENGTH.MAX) {
    return CONVERSATION_MESSAGES.TITLE_LENGTH;
  }

  return null;
};
